// MOCK podaci za Zebra Cars landing stranicu
// OVO JE SAMO FRONTEND MOCK – BEZ PRAVOG BACKENDA

export const companyInfo = {
  name: "ZEBRA CARS",
  subtitle: "Agencija za registraciju vozila i tehnički pregled",
  description:
    "Još davne 2009. godine osnovana je agencija za registraciju Zebra Cars, a tehnički pregled otvoren je 2016. godine pod nazivom Zebra Cars 2016.",
  googleRating: 4.9,
};

export const workingHours = [
  { day: "Ponedeljak – Petak", hours: "08:00 – 16:00" },
  { day: "Subota", hours: "08:00 – 14:00" },
  { day: "Nedelja", hours: "Zatvoreno" },
];

export const contact = {
  address: "Profesora Grčića 40A, Novi Sad 21000",
  phone: "0607522712",
  phoneDisplay: "060 752 27 12",
  googleMapsUrl:
    "https://www.google.com/maps/place/Zebra+Cars+Tehni%C4%8Dki+Pregled/@45.2922409,19.8138847,17z/data=!3m1!4b1!4m6!3m5!1s0x475b11d36b8570a3:0x771d7ce840d1a645!8m2!3d45.2922409!4d19.8164596!16s%2Fg%2F11ff1v_3fx?hl=sr&entry=ttu&g_ep=EgoyMDI2MDEyOC4wIKXMDSoASAFQAw%3D%3D",
};

export const services = [
  {
    category: "Kompletna registracija",
    items: [
      "Besplatna usluga dolaska po vozilo i vraćanja na istu adresu (vozilo mora biti registrovano; u suprotnom obezbeđujemo povoljnu šlep službu)",
      "Prva registracija vozila",
      "Registracija bez šetanja i čekanja",
      "Odjava i prepis vozila",
      "Kupoprodajni ugovori",
    ],
  },
  {
    category: "Tehnički pregled",
    items: [
      "Brz i korektan tehnički pregled",
      "Stručan i ljubazan tim",
      "Saveti za pripremu vozila pre pregleda",
    ],
  },
  {
    category: "Osiguranje",
    items: [
      "Auto-odgovornost",
      "Kasko osiguranje",
      "Putno osiguranje",
    ],
  },
  {
    category: "Plaćanje i dodatne usluge",
    items: [
      "Plaćanje na rate: administrativna zabrana, čekovi građana, kreditna kartica Poštanske štedionice",
      "Plaćanje svih vrsta računa putem ALTA PAY",
      "Mogućnost Wolt i Glovo uplata pazara",
    ],
  },
];

export const benefits = [
  "Registracija bez čekanja",
  "Brz i korektan tehnički pregled",
  "Besplatan dolazak po vozilo",
];
